<i18n lang="json">
    {
      "ru": {
        "Заключите один из договоров в офисе":"Заключите один из договоров в офисе",
        "one_owner": "Один владелец",
        "one_owner_subtitle": "Договор на предоставление в пользование индивидуальной сейфовой ячейки одному арендатору",
        "one_owner_description": "Возможен только один Арендатор, который может передать права доступа к арендованной им ячейке любому физическому лицу по нотариально заверенной доверенности.",
        "multiple_owners": "Несколько владельцев",
        "multiple_owners_subtitle": "Договор на предоставление в пользование индивидуальной сейфовой ячейки с раздельным доступом",
        "multiple_owners_description": "Позволяет арендовать ячейку двум Арендаторам с равными правами доступа каждому, т.е. Банк предоставляет каждому Клиенту экземпляр ключа от арендованной ячейки и обеспечивает доступ к ячейке любого из Арендаторов независимо друг от друга.",
        "special_conditions": "Особые условия",
        "special_conditions_subtitle": "Договор на предоставление в пользование индивидуальной ячейки с особыми условиями доступа",
        "special_conditions_description": "Заключается между Банком и двумя и более Арендаторами. Строго оговаривается режим доступа к ячейке каждого из Арендаторов. Чаще используется в случаях сделок купли-продажи недвижимости. Его отличие от Договора на предоставление в пользование индивидуальной сейфовой ячейки с совместным доступом в том, что Банк частично контролирует проведение сделки.",
        "convenient_for_deals": "Удобный для сделок",
        "convenient_for_deals_subtitle": "Договор на предоставление в пользование индивидуальной ячейки с совместным доступом",
        "convenient_for_deals_description": "Аренда ячейки двумя Арендаторами, часто используется в случаях сделок купли-продажи недвижимости, передачи ценностей и т.п., возможен только в случае одновременного присутствия обоих Арендаторов, поэтому Банк предоставляет только один экземпляр ключа."
      },
      "en": {
        "Заключите один из договоров в офисе":"Sign one of the contracts in the office",
        "one_owner": "One Owner",
        "one_owner_subtitle": "Contract for the provision of an individual safe deposit box to one tenant",
        "one_owner_description": "Only one tenant is allowed, who can transfer access rights to their rented box to any individual by a notarized power of attorney.",
        "multiple_owners": "Multiple Owners",
        "multiple_owners_subtitle": "Contract for the provision of an individual safe deposit box with separate access",
        "multiple_owners_description": "Allows two tenants to rent a box with equal access rights for each, i.e. the bank provides each client with a copy of the key to the rented box and ensures access to the box for either tenant independently.",
        "special_conditions": "Special Conditions",
        "special_conditions_subtitle": "Contract for the provision of an individual box with special access conditions",
        "special_conditions_description": "Concluded between the bank and two or more tenants. The access mode for each tenant is strictly specified. Often used in real estate transactions. Its difference from the contract for the provision of an individual safe deposit box with joint access is that the bank partially controls the transaction.",
        "convenient_for_deals": "Convenient for Deals",
        "convenient_for_deals_subtitle": "Contract for the provision of an individual box with joint access",
        "convenient_for_deals_description": "Renting a box by two tenants, often used in real estate transactions, transfer of valuables, etc., is only possible in the simultaneous presence of both tenants, so the bank provides only one copy of the key."
      },
      "tr": {
        "Заключите один из договоров в офисе":"Sözleşmelerden birini ofiste imzalayın",
        "one_owner": "Tek Sahip",
        "one_owner_subtitle": "Bir kiracıya bireysel kiralık kasa sağlama sözleşmesi",
        "one_owner_description": "Yalnızca bir kiracıya izin verilir, bu kiracı kiraladığı kasaya erişim haklarını noter tasdikli bir vekaletname ile herhangi bir bireye devredebilir.",
        "multiple_owners": "Birden Fazla Sahip",
        "multiple_owners_subtitle": "Ayrı erişime sahip bireysel kiralık kasa sağlama sözleşmesi",
        "multiple_owners_description": "İki kiracının her birine eşit erişim haklarıyla kasa kiralamasına izin verir, yani banka, kiralanan kasaya her iki kiracının da erişimini sağlar ve her bir müşteriye kiralanan kasanın bir anahtar kopyasını verir.",
        "special_conditions": "Özel Koşullar",
        "special_conditions_subtitle": "Özel erişim koşullarıyla bireysel kasa sağlama sözleşmesi",
        "special_conditions_description": "Banka ile iki veya daha fazla kiracı arasında akdedilir. Her kiracının erişim modu kesin olarak belirlenmiştir. Genellikle gayrimenkul işlemlerinde kullanılır. Ortak erişimli bireysel kiralık kasa sağlama sözleşmesinden farkı, bankanın işlemi kısmen kontrol etmesidir.",
        "convenient_for_deals": "İşlemler İçin Uygun",
        "convenient_for_deals_subtitle": "Ortak erişimli bireysel kasa sağlama sözleşmesi",
        "convenient_for_deals_description": "İki kiracının birlikte kiraladığı kasa, genellikle gayrimenkul işlemlerinde, değerli eşyaların transferinde vb. kullanılır, yalnızca her iki kiracının da aynı anda bulunması durumunda mümkündür, bu nedenle banka yalnızca bir anahtar kopyası sağlar."
      },
      "es": {
        "Заключите один из договоров в офисе":"Firma uno de los contratos en la oficina.",
        "one_owner": "Un Propietario",
        "one_owner_subtitle": "Contrato para la provisión de una caja de seguridad individual a un inquilino",
        "one_owner_description": "Solo se permite un inquilino, quien puede transferir los derechos de acceso a su caja alquilada a cualquier individuo mediante un poder notarial.",
        "multiple_owners": "Varios Propietarios",
        "multiple_owners_subtitle": "Contrato para la provisión de una caja de seguridad individual con acceso separado",
        "multiple_owners_description": "Permite que dos inquilinos alquilen una caja con derechos de acceso iguales para cada uno, es decir, el banco proporciona a cada cliente una copia de la llave de la caja alquilada y asegura el acceso a la caja para cualquiera de los inquilinos de manera independiente.",
        "special_conditions": "Condiciones Especiales",
        "special_conditions_subtitle": "Contrato para la provisión de una caja individual con condiciones de acceso especiales",
        "special_conditions_description": "Concluido entre el banco y dos o más inquilinos. El modo de acceso para cada inquilino está estrictamente especificado. A menudo se utiliza en transacciones inmobiliarias. Su diferencia con el contrato para la provisión de una caja de seguridad individual con acceso conjunto es que el banco controla parcialmente la transacción.",
        "convenient_for_deals": "Conveniente para Tratos",
        "convenient_for_deals_subtitle": "Contrato para la provisión de una caja individual con acceso conjunto",
        "convenient_for_deals_description": "Alquilar una caja por dos inquilinos, a menudo se usa en transacciones inmobiliarias, transferencia de objetos de valor, etc., solo es posible en presencia simultánea de ambos inquilinos, por lo que el banco solo proporciona una copia de la llave."
      },
      "ar": {
        "Заключите один из договоров в офисе":"قم بتوقيع أحد العقود في المكتب",
        "one_owner": "مالك واحد",
        "one_owner_subtitle": "عقد لتوفير صندوق إيداع آمن فردي لمستأجر واحد",
        "one_owner_description": "يسمح لمستأجر واحد فقط، والذي يمكنه نقل حقوق الوصول إلى صندوقه المؤجر إلى أي فرد من خلال توكيل رسمي موثق.",
        "multiple_owners": "عدة مالكين",
        "multiple_owners_subtitle": "عقد لتوفير صندوق إيداع آمن فردي مع وصول منفصل",
        "multiple_owners_description": "يسمح لمستأجرين اثنين باستئجار صندوق مع حقوق وصول متساوية لكل منهما، أي أن البنك يوفر لكل عميل نسخة من مفتاح الصندوق المستأجر ويضمن وصول كل مستأجر إلى الصندوق بشكل مستقل.",
        "special_conditions": "شروط خاصة",
        "special_conditions_subtitle": "عقد لتوفير صندوق فردي بشروط وصول خاصة",
        "special_conditions_description": "يُبرم بين البنك واثنين أو أكثر من المستأجرين. يتم تحديد وضع الوصول لكل مستأجر بشكل صارم. يستخدم غالبًا في معاملات العقارات. يكمن الفرق بينه وبين عقد توفير صندوق إيداع آمن فردي مع وصول مشترك في أن البنك يتحكم جزئيًا في المعاملة.",
        "convenient_for_deals": "مناسب للصفقات",
        "convenient_for_deals_subtitle": "عقد لتوفير صندوق فردي مع وصول مشترك",
        "convenient_for_deals_description": "استئجار صندوق بواسطة مستأجرين، غالبًا ما يستخدم في معاملات العقارات، نقل الأشياء الثمينة، إلخ، ولا يكون ممكنًا إلا في وجود كلا المستأجرين في نفس الوقت، وبالتالي يوفر البنك نسخة واحدة فقط من المفتاح."
      }
    }
    </i18n>
    
    <template>
        <section class="container mt-0 lg:mt-14" id="documents">
            <div class="border-[1px] border-[#E1E1E1] p-7 rounded-xl lg:block hidden">
                <p class="font-medium text-lg md:text-3xl mb-7">{{ t('Заключите один из договоров в офисе') }}</p>
                <div class="grid grid-cols-12 gap-6">
                    <div v-for="(contract, index) in contracts" :key="index"
                        class="col-span-6 pl-4 pt-4 border-[1px] h-59 border-[#E1E1E1] bg-[#F9F9F9E5] rounded-2xl relative overflow-hidden">
                        <div class="relative z-10 leading-none">
                            <p class="font-semibold text-xl mb-[10px]">{{ t(contract.title) }}</p>
                            <p class="font-semibold mb-4">{{ t(contract.subtitle) }}</p>
                            <p class="">{{ t(contract.description) }}</p>
                        </div>
    
                        <component class="absolute z-0" :is="contract.iconComponent" :class="getIconPosition(index)">
                        </component>
                    </div>
                </div>
            </div>
            <div class="lg:hidden block px-4 mb-8 mt-8">
                <div class="grid gap-4">
                    <div v-for="(contract, index) in contracts" :key="index">
                        <div class="flex justify-between" @click="onNavClick(index)">
                            <p class="text-lg" :class="[activeTab === index ? 'border-b-2 border-darkYellow' : '']">
                                {{ t(contract.title) }}
                            </p>
                            <a-icon-arrow :class="[activeTab === index ? 'rotate-180' : '']"></a-icon-arrow>
                        </div>
                        <div v-if="activeTab === index" class="pr-8">
                            <p class="font-semibold mb-4">{{ t(contract.subtitle) }}</p>
                            <p>{{ t(contract.description) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </template>
    
    <script setup>
    import Agreement from '@/components/a-icon/a-icon-agreement.vue';
    import { ref } from 'vue';
    const { t } = useI18n({ useScope: 'local' });
    const activeTab = ref(null);
    
    function onNavClick(tab) {
        activeTab.value = activeTab.value === tab ? null : tab;
    }
    
    const contracts = [
        {
            title: 'one_owner',
            subtitle: 'one_owner_subtitle',
            description: 'one_owner_description',
            iconComponent: Agreement,
        },
        {
            title: 'multiple_owners',
            subtitle: 'multiple_owners_subtitle',
            description: 'multiple_owners_description',
            iconComponent: Agreement,
        },
        {
            title: 'special_conditions',
            subtitle: 'special_conditions_subtitle',
            description: 'special_conditions_description',
            iconComponent: Agreement,
        },
        {
            title: 'convenient_for_deals',
            subtitle: 'convenient_for_deals_subtitle',
            description: 'convenient_for_deals_description',
            iconComponent: Agreement,
        }
    ];
    
    const getIconPosition = (index) => {
        switch (index) {
            case 0:
                return 'top-0 -left-2 -rotate-90';
            case 1:
                return 'top-0 right-0';
            case 2:
                return 'bottom-0 left-0 -rotate-180';
            case 3:
                return 'bottom-0 -right-2 rotate-90';
            default:
                return '';
        }
    };
    </script>